import { motion } from 'framer-motion';
import SEO, { StructuredData } from '../components/SEO';
import PricingSection from './landing/PricingSection';
import FAQSection from './landing/FAQSection';
import FinalCTASection from './landing/FinalCTASection';

export default function PricingPage() {
  return (
    <div data-testid="pricing-page">
      <SEO page="pricing" />
      <StructuredData type="service" />
      
      {/* Hero */}
      <section className="py-20 gradient-mesh">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-rm-text mb-6">
              Tarifs simples et transparents
            </h1>
            <p className="text-lg md:text-xl text-rm-text-secondary">
              Choisis la formule qui correspond à tes besoins. 
              Sans engagement, évolutif selon tes objectifs.
            </p>
          </motion.div>
        </div>
      </section>

      <PricingSection />
      <FAQSection />
      <FinalCTASection />
    </div>
  );
}
